module.exports = __webpack_public_path__ + "static/media/SSWhiteP.e6d411fd.png";